<template>
  <div class="login-modal-inner">
    <!-- Branded Header -->
    <div class="login-brand-header">
      <img src="../../icons/Logo.svg" alt="Renants" class="login-brand-logo" />
      <p class="login-brand-tagline">Your local community marketplace</p>
    </div>

    <div class="register-box login-form-body">
    <!-- Title -->
    <h2 class="title">Create New Account</h2>
    <p class="subtitle">Join Renants — it's free!</p>

    <!-- Account Type Selection -->
<div class="group">
  <label>Account Type</label>
  <div class="account-type-simple">
    <label :class="{ active: accountType === 'individual' }">
      <input
        type="radio"
        value="individual"
        v-model="accountType"
      />
      👤 Individual
    </label>

    <label :class="{ active: accountType === 'business' }">
      <input
        type="radio"
        value="business"
        v-model="accountType"
      />
      🏢 Business
    </label>
  </div>
</div>

    <!-- First + Last Name -->
    <div class="row-2">
      <div>
        <label>Full Name</label>
        <input type="text" v-model="fullName" placeholder="Enter Name" />
      </div>
    </div>

    <!-- Email -->
    <div class="group">
      <label>Email</label>
      <input type="email" v-model="email" placeholder="Enter Email ID" />
    </div>

    <!-- Password -->
    <!-- Password -->
    <div class="group password-wrapper">
      <label>Enter New Password</label>
      <input
        :type="showPassword ? 'text' : 'password'"
        v-model="password"
        placeholder="Enter Password"
      />
      <span class="toggle-password" @click="togglePassword">
        <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
      </span>
    </div>

    <!-- Confirm Password -->
    <div class="group password-wrapper">
      <label>Re-enter New Password</label>
      <input
        :type="showConfirmPassword ? 'text' : 'password'"
        v-model="confirmPassword"
        placeholder="Re Enter Password"
      />
      <span class="toggle-password" @click="toggleConfirmPassword">
        <i :class="showConfirmPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
      </span>
    </div>

    <!-- OTP -->
    <div v-if="showOtpInput" class="group">
      <label>Enter OTP</label>
      <input type="text" v-model="otp" placeholder="Enter OTP" />
    </div>

    <!-- Main Button -->
    <button
      type="button"
      class="btn btn-primary btn-sm w-100"
      :disabled="loading"
      @click="handleRegister"
    >
      {{ showOtpInput ? "Verify OTP & Register" : "Email OTP" }}
      <span v-if="loading" class="spinner-border spinner-border-sm"></span>
    </button>
    <p class="footer">
      Already have an account?
      <span class="link" @click="$emit('switchMode', 'login')">Sign In</span>
    </p>
    </div><!-- end register-box -->
  </div>
</template>
<script>
import axios from "axios";
import { toast } from "vue-sonner";
import { UAParser } from "ua-parser-js";
import { trackEvent } from "@/composables/useAnalytics";
import { getRecaptchaToken } from "@/utils/recaptcha";
export default {
  data() {
    return {
      fullName: "",
      email: "",
      userName: "",
      password: "",
      confirmPassword: "",
      otp: "",
      showOtpInput: false,
      loading: false,
      showPassword: false,
      showConfirmPassword: false,
      accountType: "individual",
    };
  },
  mounted() {
    this.trackVisitor();
    this.loadGoogleAnalytics();
  },
  methods: {
    async trackVisitor() {
      const parser = new UAParser();
      const browserInfo = parser.getResult();

      const visitData = {
        timestamp: new Date().toISOString(),
        browser: browserInfo.browser.name,
        browserVersion: browserInfo.browser.version,
        os: browserInfo.os.name,
        osVersion: browserInfo.os.version,
        device: browserInfo.device.type || "Desktop",
        pageName: "Register Page",
        screenResolution: `${window.screen.width}x${window.screen.height}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      try {
        const response = await fetch("https://api64.ipify.org?format=json");
        const { ip } = await response.json();
        visitData.ip = ip;

        await fetch("/api/visitors", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(visitData),
        });
      } catch (error) {
        console.error("Error tracking visitor:", error);
      }
    },

    loadGoogleAnalytics() {
      const gaId = import.meta.env.VITE_GA_MEASUREMENT_ID;
      if (!gaId) return Promise.resolve();
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(script);

      return new Promise((resolve, reject) => {
        script.onload = () => {
          window.dataLayer = window.dataLayer || [];
          window.gtag = (...args) => window.dataLayer.push(args);
          window.gtag("js", new Date());
          window.gtag("config", gaId);
          resolve();
        };

        script.onerror = () => {
          console.error("Failed to load Google Analytics.");
          reject(new Error("GA script load failed"));
        };
      });
    },

    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    validatePassword() {
  if (!this.password) {
    toast.error("Please enter password");
    return false;
  }

  if (this.password.length < 6) {
    toast.error("Password must be at least 6 characters");
    return false;
  }

  if (!this.confirmPassword) {
    toast.error("Please confirm password");
    return false;
  }

  if (this.password !== this.confirmPassword) {
    toast.error("Passwords do not match");
    return false;
  }

  return true;
},

    async handleRegister() {
      // Guard as well as :disabled — a fast double-click can land two events
      // before Vue has re-rendered the button as disabled.
      if (this.loading) return;
      this.loading = true;
      // console.log(password.value);
      if (!this.showOtpInput) {
          // ✅ PASSWORD VALIDATION FIRST
  if (!this.validatePassword()) {
    this.loading = false;
    return;
  }
        try {
          const checkResponse = await axios.post("/api/getoneusers", {
            email: this.email,
          });

          if (checkResponse.data.length >= 1) {
            toast.error("Email already exists.");
            this.loading = false;
            return;
          }
        } catch (err) {
          toast.error("Failed to check user existence..");
          this.loading = false;
          return;
        }

        // Step 2: Send OTP
        try {
          const recaptchaToken = await getRecaptchaToken('otp_send');
          const response = await axios.post("/api/sendotp", {
            email: this.email,
            recaptchaToken,
          });
          console.log(response);
          if (response.status === 200) {
            this.showOtpInput = true;
            toast.success("OTP sent to your email");
          } else {
            toast.error("Failed to send OTP");
          }
        } catch (err) {
          toast.error("Error occurred while sending OTP or checking user.");
          this.loading = false;
        } finally {
          this.loading = false;
        }
      } else {
        try {
          await axios.post("/api/verifyotp", {
            email: this.email,
            otp: this.otp,
          });
          this.userName = this.email.match(/^[^@]+/)[0];
          console.log("email and password check", this.email + this.password);
          const recaptchaToken = await getRecaptchaToken('register');
          const registerResponse = await axios.post("/api/register", {
            fullName: this.fullName,
            userName: this.userName,
            email: this.email,
            secKey: this.password,
            role: "userOrg",
            accountType: this.accountType, // <-- send to backend
            recaptchaToken,
          });
          console.log(registerResponse);
          trackEvent('sign_up', { method: 'email', account_type: this.accountType });
          toast.success("Registration successful!");
          this.$emit("switchMode", "login");
        } catch (err) {
          console.log(err);
          if (err.response?.status === 409) {
            toast.error("email is already registered.");
            this.loading = false;
          } else {
            toast.error("OTP verification or registration failed.");
            this.loading = false;
          }
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
/* ── Brand Header ── */
.login-brand-header {
  background: linear-gradient(135deg, #1d3fa8 0%, #3467d5 60%, #5b87f0 100%);
  border-radius: 14px 14px 0 0;
  padding: 22px 24px 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.login-brand-logo {
  height: 32px;
  filter: brightness(0) invert(1);
}
.login-brand-tagline {
  color: rgba(255,255,255,0.75);
  font-size: 12px;
  font-family: var(--font-primary);
  margin: 0;
}
.login-form-body {
  padding: 24px 24px 20px;
}

.register-box {
  width: 100%;
}

/* HEADER */
.title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 2px;
}

.subtitle {
  font-size: 14px;
  margin-bottom: 18px;
  color: #6b6b6b;
}

/* ROW 2 FIELDS */
.row-2 {
  display: flex;
  gap: 12px;
  margin-bottom: 14px;
}

.row-2 > div {
  flex: 1;
}

/* LABEL + INPUT */
label {
  font-size: 14px;
  margin-bottom: 6px;
  display: block;
  color: #444;
}

input,
select {
  width: 100%;
  padding: 10px 12px;
  font-size: 14px;
  border-radius: 6px;
  border: 1px solid #d7d7d7;
}

/* .group {
  margin-bottom: 14px;
} */

input:focus,
select:focus {
  border-color: #1d5ce6;
  outline: none;
}

.required {
  color: red;
}

/* MOBILE NUMBER BOX */
.mobile-box {
  display: flex;
  gap: 8px;
}

.country {
  padding: 10px 14px;
  border: 1px solid #d7d7d7;
  background: #f7f7f7;
  border-radius: 6px;
  font-size: 14px;
}

/* CHECKBOX */
.check {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  margin-bottom: 12px;
}

/* SUBMIT BUTTON */
.btn {
  width: 100%;
  padding: 12px;
  background: #1d5ce6;
  color: white;
  border-radius: 6px;
  font-size: 15px;
  border: none;
  margin-top: 6px;
  cursor: pointer;
}

/* FOOTER */
.footer {
  text-align: center;
  margin: 0;
  font-size: 14px;
}

.link {
  color: #1d5ce6;
  cursor: pointer;
  font-weight: 500;
}
.password-wrapper {
  position: relative;
}

.password-wrapper input {
  padding-right: 40px;
}

.toggle-password {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-15%);
  cursor: pointer;
  color: #6b7280;
  font-size: 18px;
}



.account-type-simple {
  display: flex;
  gap: 10px;
}

.account-type-simple label {
  flex: 1;
  border: 1px solid #d7d7d7;
  border-radius: 6px;
  padding: 10px 12px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
}

.account-type-simple input {
  display: none;
}

.account-type-simple label.active {
  border-color: #1d5ce6;
  background: #eef3ff;
  color: #1d5ce6;
  font-weight: 500;
}

</style>
